export default [
  {
    path: "/stormwater",
    component: () => import("../layout/PageLayoutWithoutContainer.vue"),
    beforeEnter: (to, from, next) => {
      if (process.env.VUE_APP_ENABLE_STORMWATER === "true") {
        next();
      } else {
        next({ path: "/page-not-found" });
      }
    },
    children: [
      {
        path: "",
        name: "Stormwater estimator",
        component: () => import("@/views/Stormwater/Stormwater.vue")
      }
    ]
  }
];
